import { Box } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Group } from '@work4all/models/lib/Classes/Group.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { IFilterPickerConfig } from '../../../../components/entity-picker/components/list-entity-picker';
import { EntityGroupPicker } from '../../../../components/entity-picker/entity-group-picker/EntityGroupPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type EntityGroupFilterCardProps = {
  title: string;
  value: Group[] | null;
  onChange: (value: Group[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
  filterConfig?: IFilterPickerConfig;
  entity: Entities;
};

function EntityGroupFilterCard(props: EntityGroupFilterCardProps) {
  const { title, value, onChange, expanded, onExpandedChange, entity } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    if (value.length === 1) return value[0].name;
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <Box maxHeight="30rem" overflow="auto" margin="1rem">
        <EntityGroupPicker
          entity={entity}
          multiple={true}
          value={value}
          onChange={(newValue) => {
            onChange(newValue);
          }}
        />
      </Box>
    </FilterCard>
  );
}

export const ProjectGroupFilterCard = (
  props: Omit<EntityGroupFilterCardProps, 'entity'>
) => <EntityGroupFilterCard entity={Entities.projectGroup} {...props} />;

export const ArticleGroupFilterCard = (
  props: Omit<EntityGroupFilterCardProps, 'entity'>
) => <EntityGroupFilterCard entity={Entities.articleGroup} {...props} />;

export const CustomerGroupFilterCard = (
  props: Omit<EntityGroupFilterCardProps, 'entity'>
) => <EntityGroupFilterCard entity={Entities.customerGroup} {...props} />;

export const SupplierGroupFilterCard = (
  props: Omit<EntityGroupFilterCardProps, 'entity'>
) => <EntityGroupFilterCard entity={Entities.supplierGroup} {...props} />;

export const ServiceContractGroupFilterCard = (
  props: Omit<EntityGroupFilterCardProps, 'entity'>
) => <EntityGroupFilterCard entity={Entities.contractGroup} {...props} />;
